var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnarchive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 1.25A1.75 1.75 0 0 0 .25 3v3h1v7c0 .966.784 1.75 1.75 1.75h4v-1.5H3a.25.25 0 0 1-.25-.25V6h10.5v2h1.5V6h1V3A1.75 1.75 0 0 0 14 1.25H2zM14.25 4.5V3a.25.25 0 0 0-.25-.25H2a.25.25 0 0 0-.25.25v1.5h12.5z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM9.414 12.469a.75.75 0 0 1 .117-1.055l2.5-2a.75.75 0 0 1 .937 0l2.5 2a.75.75 0 1 1-.937 1.172L13.25 11.56v2.94a.75.75 0 0 1-1.5 0v-2.94l-1.282 1.026a.75.75 0 0 1-1.054-.117z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnarchive);
export default ForwardRef;